import React from "react";
import { Database, CheckCircle2, AlertTriangle } from "lucide-react";
import { ago } from "@/lib/mongoMcp";

// Non-hub servers: the connection the hub delivered (read-only, no token).
export default function SpokeConnectionCard({ data }) {
    const c = data.connection || {};
    const fm = data.field_map || {};
    const pullError = data.last_pull?.error;
    return (
        <section className="rounded-lg border border-white/10 bg-gradient-to-br from-white/[0.025] to-transparent p-4" data-testid="mongo-servers-spoke">
            <div className="flex items-start gap-2.5">
                <Database className="w-4 h-4 text-emerald-300 mt-0.5" strokeWidth={1.5} />
                <div className="flex-1 min-w-0">
                    <h2 className="text-sm font-medium">MongoDB server</h2>
                    <p className="text-[11px] text-white/45 mt-0.5">
                        {data.role === "unlinked" ? "Link this environment to the Radar hub (Settings → Radar Sync) to receive its MongoDB connection."
                            : <>Managed on the Radar hub{data.hub_url ? <> (<span className="font-mono">{data.hub_url}</span>)</> : null} — change it on the hub's Connections page.</>}
                    </p>
                    <div className="mt-3 flex items-center gap-2 text-xs" data-testid="mongo-spoke-connection-state">
                        {c.configured ? <CheckCircle2 className="w-3.5 h-3.5 text-emerald-300" /> : <AlertTriangle className="w-3.5 h-3.5 text-amber-300" />}
                        {c.configured ? <span><span className="font-display text-base">{c.label}</span> <span className="font-mono text-white/55">{c.url}</span> · received {ago(c.received_at)}</span>
                            : <span className="text-amber-200">No connection received yet — MongoDB tools are off on this server.</span>}
                    </div>
                    <div className="mt-1.5 text-[11px] text-white/45 font-mono" data-testid="mongo-spoke-field-map">
                        Field map v{fm.version || 0}{fm.received_at ? ` · received ${ago(fm.received_at)}` : ""}
                    </div>
                    {pullError && <div className="mt-1.5 text-[11px] text-amber-200/90" data-testid="mongo-spoke-pull-error">Last check with the hub: {pullError}</div>}
                </div>
            </div>
        </section>
    );
}
